__turbopack_context__.v({
  "border": "BasicListItem-module-scss-module__wrsh9G__border",
  "center": "BasicListItem-module-scss-module__wrsh9G__center",
  "ellipsis": "BasicListItem-module-scss-module__wrsh9G__ellipsis",
  "left": "BasicListItem-module-scss-module__wrsh9G__left",
  "max_width": "BasicListItem-module-scss-module__wrsh9G__max_width",
  "over_text": "BasicListItem-module-scss-module__wrsh9G__over_text",
  "right": "BasicListItem-module-scss-module__wrsh9G__right",
  "right_inner": "BasicListItem-module-scss-module__wrsh9G__right_inner",
  "sub_text": "BasicListItem-module-scss-module__wrsh9G__sub_text",
  "title": "BasicListItem-module-scss-module__wrsh9G__title",
  "title_text": "BasicListItem-module-scss-module__wrsh9G__title_text",
  "wrapper": "BasicListItem-module-scss-module__wrsh9G__wrapper",
});
